import Typography from '@mui/joy/Typography';
import { makeTable } from "../../../components/MakeTable";
import { BlueLink } from '../../../components/BlueLink';
import { useListContext } from '../../../provider/ListProvider';
import { useInfo } from '../../../utils/hooks/useInfo';
import { useLanguageContext } from '../../../context/LanguageContext';
import { AdverStatApi } from '../../../utils/crud/adver_stat_api';
import { listEffect } from '../../../utils/hooks/listEffect';
function AdverLink({ id, domain }) {
  if (id)
    return <BlueLink to={`/analytics/advertiser/view/${id}`} level="body-xs">{domain}</BlueLink>
  else
    return <Typography level="body-xs">{domain}</Typography>
}
export const UniqTable = makeTable(
  [
    {
      field: 'domain',
      sortable: true,
      label: 'Domain',
      Element: ({ row }) => <AdverLink key="domain" id={row.id} domain={row.domain} />
    },
    {
      field: 'users',
      sortable: true,
      label: 'Unique users',
      Element: ({ row }) => <Typography key="users" level="body-xs">{row.users}</Typography>
    },
  ],
  [],
  'Total',
  'domain'
)
const adver_stat_api = new AdverStatApi();
const getLoader = (info, t, setUniqTopLoading, setUniqTop) => {
  return async (listContext) => {
    setUniqTopLoading(true)
    let res = await adver_stat_api.getUniqTopTable(listContext)
    if (res.is_error) {
      setUniqTop(null)
      if (!res.error) res.error = {}
      res.error.message = t("Load error") // ошибка которая будет отображена в таблице
      info(res.error.message, "danger") // ошибка во всплывашке
      return res
    }
    setUniqTop(res.data)
    setUniqTopLoading(false)
    return res;
  }
}
export function UniqTableWrapper({ setUniqTopLoading, setUniqTop }) {
  const { t } = useLanguageContext();
  const listContext = useListContext();
  const info = useInfo();
  listEffect(listContext, getLoader(info, t, setUniqTopLoading, setUniqTop))
  return <UniqTable></UniqTable>
}